import {
	handleErrorWithSentry,
	replayIntegration,
	browserProfilingIntegration
} from '@sentry/sveltekit';
import * as Sentry from '@sentry/sveltekit';
import { PUBLIC_SENTRY_ENVIRONMENT } from '$env/static/public';

Sentry.init({
	dsn: 'https://d77176e246a7acbfb400d59599b49735@o4507142862143488.ingest.de.sentry.io/4507142876037200',
	tracesSampleRate: 1.0,
	tracePropagationTargets: [/^https:\/\/envisionly\.tech/],

	environment: PUBLIC_SENTRY_ENVIRONMENT,

	// This sets the sample rate to be 10%. You may want this to be 100% while
	// in development and sample at a lower rate in production
	replaysSessionSampleRate: 0.1,

	// If the entire session is not sampled, use the below sample rate to sample
	// sessions when an error occurs.
	replaysOnErrorSampleRate: 1.0,
	// If you don't want to use Session Replay, just remove the line below:
	integrations: [replayIntegration(), browserProfilingIntegration()]
});

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = handleErrorWithSentry();
